import type {Result, UseCase} from 'framework';
import type {ScheduleError} from '../../domain/errors';
import type {SaveScheduleWeekEntry} from '../../domain/schedule-week-slot';
import type {ScheduleRepository} from '../ports/schedule.repository';

export type SaveScheduleWeekInput = {
  readonly entries: readonly SaveScheduleWeekEntry[];
};

export class SaveScheduleWeek implements UseCase<[SaveScheduleWeekInput], void> {
  constructor(private readonly repository: ScheduleRepository) {}

  execute(input: SaveScheduleWeekInput): Promise<Result<void, ScheduleError>> {
    return this.repository.saveWeek(input.entries);
  }
}
